import { Injectable, OnDestroy, signal } from '@angular/core';

/**
 * Tracks HTTP retry progress for UI feedback
 * Used by retry interceptor to notify when retries occur
 * Auto-resets after delay to clean up state
 */
@Injectable({ providedIn: 'root' })
export class RetryProgressService implements OnDestroy {
  ngOnDestroy(): void {
    throw new Error('Method not implemented.');
  }
  readonly currentAttempt = signal(0);
  readonly isRetrying = signal(false);

  notifyRetry(attempt: number): void {
    this.currentAttempt.set(attempt);
    this.isRetrying.set(true);
  }

  reset(): void {
    this.currentAttempt.set(0);
    this.isRetrying.set(false);
  }
}
